import styled from 'styled-components';

const MockPlanContainer = styled.div`
  display: flex;
  place-content: center;
`;

export const Styled = {
  MockPlanContainer,
};
